
import auth from './AuthAPI.js'
import * as APPCONFIG from '../config/app-config.js'
import Http from './Http.js';

class TaskApi {
  
    saveTask(form) {
        return auth({
          method: "post",
          headers: Http.AUTH_HEADERS(),
          url: `${APPCONFIG.API_URL}api/saveTaskV2`,
          data: JSON.stringify(form),
        });
      }   

      editTask(form) {
        return auth({
          method: "post",
          headers: Http.AUTH_HEADERS(),
          url: `${APPCONFIG.API_URL}api/editTaskV2`,
          data: JSON.stringify(form),
        });
      }   


      getTask(form) {
        return auth({
          method: "post",
          headers: Http.AUTH_HEADERS(),
          url: `${APPCONFIG.API_URL}api/getTask`,
          data: JSON.stringify(form),
        });
      }   

      deleteTask(form) {
        return auth({
          method: "post",
          headers: Http.AUTH_HEADERS(),
          url: `${APPCONFIG.API_URL}api/deleteTask`,
          data: JSON.stringify(form),
        });
      }   

      updateTask(form){
        return auth({
          method: "post",
          headers: Http.AUTH_HEADERS(),
          url: `${APPCONFIG.API_URL}api/updateTask`,
          data: JSON.stringify(form),
        })
      }




    }
   
    export default new TaskApi();   